export enum BoardGamesEventPostMessageType {
  Close = 'BGE/CLOSE',
  Payment = 'BGE/PAYMENT',
  RefreshResources = 'BGE/REFRESH_RESOURCES',
  MiniGameOpen = 'BGE/MINIGAME_OPEN',
  MiniGameClose = 'BGE/MINIGAME_CLOSE',
}
